import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProjectItemType } from '../../models/project/project-item-type.enum';
import { ProjectSectionItem } from '../../models/project/project-section-item.model';
import { OrganizationType } from '../../models/staff/organization-type.enum';
import { NzTreeNode } from '../../models/tree-node.model';
import { EventService, EventType } from '../../providers/event.service';
import { GlobalService } from '../../providers/global.service';

@Component({
  selector: 'wbs-jg-cascader',
  templateUrl: './wbs-jg-cascader.component.html',
  styleUrls: ['./wbs-jg-cascader.component.scss'],
})
export class WbsJgCascaderComponent {
  async onChange() {
    const section = await this.globalService.getWbsTitleTree();
    const treeNodes: NzTreeNode[] = [];
    for (const item of section?.child ?? []) {
      if (!this.filterSectionIds.includes(item.sectionId!)) {
        continue;
      }
      treeNodes.push(this.buildTreeNodes(item));
    }
    this.unitTreeNodes = treeNodes;
    if (this._unitCascaderValue.length === 0) {
      this._unitCascaderValue = [
        this.unitTreeNodes[0].value,
        this.unitTreeNodes[0].value,
      ];
      this.unitCascaderValueChange.emit(this._unitCascaderValue);
    }
  }

  subsciption = async () => await this.onChange();

  @Input()
  set unitCascaderValue(value: any[]) {
    this._unitCascaderValue = value;
  }

  get unitCascaderValue(): any[] {
    return this._unitCascaderValue;
  }

  _unitCascaderValue: any[] = [];

  @Output() unitCascaderValueChange = new EventEmitter<any[]>();

  unitTreeNodes: NzTreeNode[] = [];

  @Input()
  set filterSectionIds(value: number[]) {
    this._filterSectionIds = value;
    setTimeout(async () => {
      await this.onChange();
    }, 100);
  }

  get filterSectionIds(): number[] {
    return this._filterSectionIds;
  }

  _filterSectionIds: number[] = [];

  constructor(
    private globalService: GlobalService,
    private events: EventService,
  ) {}

  async ngOnInit() {
    this.events.on(EventType.WbsTitleChangeEvent, this.subsciption);
    await this.onChange();
  }

  ngOnDestroy(): void {
    this.events.destroyListener(
      EventType.WbsTitleChangeEvent,
      this.subsciption,
    );
  }

  onUnitCascaderValueChange() {
    console.log(this._unitCascaderValue);

    if (this._unitCascaderValue.length !== 0) {
      this.unitCascaderValueChange.emit(this._unitCascaderValue);
    }
  }

  onUnitCascaderClear() {
    this.unitCascaderValue = [];
    this.onUnitCascaderValueChange();
  }

  private buildTreeNodes(item: ProjectSectionItem): NzTreeNode {
    const node: NzTreeNode = {
      label:
        item.type === ProjectItemType.PROJECT_SECTION
          ? item.name
          : (item.code ?? '') + ' ' + item.name,
      value: `${item.type}#${
        item.type === ProjectItemType.SECTION ||
        item.type === ProjectItemType.PROJECT_SECTION
          ? item.id
          : item.code
      }`,
      children: item.child
        ? [
            {
              label:
                '全部' +
                (item.type === ProjectItemType.PROJECT_SECTION
                  ? '单位工程（路基路面除外）'
                  : ''),
              value: `${item.type}#${
                item.type === ProjectItemType.SECTION ||
                item.type === ProjectItemType.PROJECT_SECTION
                  ? item.id
                  : item.code
              }`,
              isLeaf: true,
            },
          ]
        : [],
      isLeaf: false,
      hasBeam: !!item.includeBeamYard,
    };
    for (const child of item.child ?? []) {
      node.children!.push(this.buildTreeNodes(child));
    }
    if (node.children?.length === 0) {
      node.isLeaf = true;
    }
    return node;
  }
}
